import styled from '@emotion/styled';

import { colors } from '../../../../styles/colors';
import { MediaBP as MQ } from '../../../../styles/mediaQuery';
import { skeletonLoading } from '../../../../styles/styles';
import { flex } from '../../../../styles/utils';

export const Container = styled.div`
  width: 100%;
  ${flex('column', 'start', 'start')};
  color: ${colors.white};
  height: 200px;
  margin-bottom: 180px;
  padding: 0px 16px;
  ${MQ.MediaSm} {
    padding: 0px;
  }
`;

export const Header = styled.div`
  &::before {
    content: '';
    border-radius: 6px;
    background-color: ${colors.TemplateLoaderAccent};
    width: 220px;
    height: 32px;
    display: block;
    margin-bottom: 13px;
    margin-top: 24px;
    ${MQ.MediaLg} {
      height: 48px;
    }
  }
`;

export const TagSkeleton = styled.div`
  &::before {
    content: '';
    border-radius: 4px;
    background-color: ${colors.TemplateLoaderAccent};
    width: 24px;
    height: 24px;
    display: inline-block;
    margin-bottom: 13px;
  }
  &::after {
    content: '';
    border-radius: 12px;
    background-color: ${colors.TemplateLoaderAccent};
    width: 280px;
    height: 20px;
    display: inline-block;
    margin-bottom: 13px;
    margin-left: 10px;
  }
`;

export const MetaButtonSkeleton = styled.div`
  border-radius: 6px;
  background-color: ${colors.TemplateLoaderAccent};
  width: 100px;
  height: 40px;
`;
export const DescriptionSkeletonLoader = styled.div`
  width: 100%;
  &::before {
    content: '';
    border-radius: 12px;
    height: 250px;
    background-color: ${colors.TemplateLoaderTrayBgDesktop};
    width: 100%;
    display: block;
    margin-bottom: 13px;
  }
  position: relative;
  ${skeletonLoading}
`;
